// extracted by mini-css-extract-plugin
export default {"active":"ThemeChangeModal_active__U4NuU"};